import { Type } from 'class-transformer';
import { IsString, IsNumber, IsEnum, Matches, Min } from 'class-validator';
import { WccStatus } from './enums/wcc-statuses';
import { InvoiceDto } from './invoice.dto';
import { SignerDto } from './signer.dto';
import { DownloadFileDto, FileInfoDto } from './download-file.dto';

export class WccDto {
  @IsNumber()
  id: number;

  @IsString()
  wccNumber: string;

  date: string;

  status: WccStatus;

  @Type()
  invoice: InvoiceDto;

  amount: number;
  sellerSignerId: number;

  @Type()
  sellerSigner: SignerDto;
  aktFile: DownloadFileDto | null;
  aktFiles: DownloadFileDto[];
  updFile: DownloadFileDto | null;
  updFiles: DownloadFileDto[];
  otherFiles: DownloadFileDto[];
  exported: boolean;
}

export class UpdateWccDto {
  @IsNumber()
  id: number;

  @IsEnum(WccStatus)
  status: WccStatus;

  @Type()
  date: Date;

  amount: number;

  sellerSignerId: number;
}

export class InvoiceWccDto {
  wcc: WccDto;
}

export class CreateInvoiceWccDto {
  @IsNumber()
  invoiceId: number;
}

export class CreateInvoiceWccSupplierDto {
  @IsNumber()
  invoiceId: number;

  @IsString()
  @Matches(/\S/, { message: 'Номер акта не должен быть пустым' })
  wccNumber: string;

  date: Date;

  @IsNumber({ allowNaN: false, allowInfinity: false, maxDecimalPlaces: 2 }, { message: 'Сумма должна быть числом с точкой, не более двух знаков после неё' })
  @Min(0, { message: 'Сумма не может быть отрицательной' })
  amount: number;
}

export class UpdateInvoiceWccSupplierDto extends UpdateWccDto {
  @IsNumber({ allowNaN: false, allowInfinity: false, maxDecimalPlaces: 2 }, { message: 'Сумма должна быть числом с точкой, не более двух знаков после неё' })
  @Min(0, { message: 'Сумма не может быть отрицательной' })
  amount: number;

  @IsString()
  @Matches(/\S/, { message: 'Номер акта не должен быть пустым' })
  wccNumber: string;

  aktFile: DownloadFileDto | null;
  aktFiles: DownloadFileDto[];
  updFile: DownloadFileDto | null;
  updFiles: DownloadFileDto[];
  otherFiles: DownloadFileDto[];
}

export class FileWccInfoDto extends WccDto{
  invoice: InvoiceDto;
  exportedFile: FileInfoDto;
}
